module.exports = __webpack_public_path__ + "static/img/2.c7542fa4.jpg";